import type { ReactNode, Dispatch, SetStateAction } from 'react';
import { createContext, useContext, useState, useMemo } from 'react';

const EditorConfigContext = createContext<EditorConfigContextProps>({} as EditorConfigContextProps);

export interface EditorConfigContextProps {
  isConfigLoaded: boolean;
  setIsConfigLoaded: Dispatch<SetStateAction<boolean>>;
  isSignatureLoaded: boolean;
  setIsSignatureLoaded: Dispatch<SetStateAction<boolean>>;
}

export const EditorConfigProvider = ({ children }: { children: ReactNode }) => {
  const [isConfigLoaded, setIsConfigLoaded] = useState<boolean>(false);
  const [isSignatureLoaded, setIsSignatureLoaded] = useState<boolean>(false);

  const value = useMemo(
    () => ({ isConfigLoaded, setIsConfigLoaded, isSignatureLoaded, setIsSignatureLoaded }),
    [isConfigLoaded, isSignatureLoaded]
  );

  return <EditorConfigContext.Provider value={value}>{children}</EditorConfigContext.Provider>;
};

export const useEditorConfig = () => {
  const context = useContext(EditorConfigContext);
  if (context === null) {
    throw new Error('useEditorConfig must be used within a EditorConfigProvider');
  }
  return context;
};
